import React from 'react';
import PropTypes from 'prop-types';
import {Toggle} from '@/components/atoms';
import {joinPerfectStoreToggleSchema} from './schemas';

const AdditionalOptionsSection = ({formData, onChange}) => {
  return (
    <div
      className='filters-partners'
      data-testid='perfect-store-additional-options'>
      <Toggle
        value={!!formData?.requiredUserToJoin}
        updateValue={(val) => onChange({...formData, requiredUserToJoin: val})}
        uiSchema={joinPerfectStoreToggleSchema}
        id='join-perfect-store'
      />
    </div>
  );
};

AdditionalOptionsSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default React.memo(AdditionalOptionsSection);
